<template>
    <vxe-table show-overflow highlight-hover-row highlight-current-row auto-resize border="none" height="100%" :data="hwTypeList" class="mytable-scrollbar">
        <vxe-table-column type="seq" width="60"></vxe-table-column>
        <vxe-table-column field="hwCode1" width="80" title="危废种类" show-overflow="title"></vxe-table-column>
        <vxe-table-column field="alias" width="220" title="俗称" show-overflow="title"></vxe-table-column>
        <vxe-table-column field="hwCode2" width="100" title="危废代码" show-overflow="title"></vxe-table-column>
        <vxe-table-column field="hwName2" title="代码名称" show-overflow="title"></vxe-table-column>
    </vxe-table>
</template>

<script>
/* eslint-disable */
export default {
    name: "HwTypeList",
    data() {
        return {
            hwTypeList: [],
        };
    },
    mounted() {
        this.getAllHwItems();
    },
    methods: {
        getAllHwItems() {
            this.organizationInfo = {};
            this.$api
                .getAllHwItems()
                .then((result) => {
                    if (result.ok === true) {
                        this.hwTypeList = result.data;
                    }
                })
                .catch((error) => {
                    console.log(error);
                });
        },
    },
};
</script>